export const translations = {
  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      discovery: 'Discovery',
      clipsLibrary: 'Clips Library',
      publishing: 'Publishing',
      analytics: 'Analytics',
      reports: 'Reports',
      settings: 'Settings',
    },
    // Auth
    auth: {
      createAccount: 'Create Account',
      startFreeTrial: 'Start your free trial today',
      fullName: 'Full Name',
      password: 'Password',
      referralCode: 'Referral Code',
      optional: 'Optional',
      termsAgree: 'By creating an account, you agree to our Terms of Service and Privacy Policy',
      haveAccount: 'Already have an account?',
      signIn: 'Sign in',
      verifyEmail: 'Verify Your Email',
      verificationSentTo: 'We sent a verification code to',
      verificationCode: 'Verification Code',
      resendCode: 'Resend Code',
      changeEmail: 'Use a different email',
      verificationCodeSent: 'Verification code sent to your email',
      emailVerified: 'Email verified successfully!',
      invalidCode: 'Please enter a valid 6-digit code',
      codeSent: 'New verification code sent',
      accountCreated: 'Account created successfully!',
      registrationFailed: 'Registration failed',
      verificationFailed: 'Verification failed',
      resendFailed: 'Failed to resend code',
      passwordMinLength: 'Password must be at least 6 characters',
    },
    // Account
    account: {
      title: 'Account',
      changePassword: 'Change Password',
      changePasswordDesc: 'Update your account password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      passwordChanged: 'Password changed successfully',
      passwordChangeFailed: 'Failed to change password',
      passwordMismatch: 'Passwords do not match',
      accountInfo: 'Account Information',
      plan: 'Plan',
      emailVerified: 'Email Verified',
      verified: 'Verified',
      notVerified: 'Not Verified',
    },
    // Dashboard
    dashboard: {
      welcomeBack: 'Welcome Back',
      monitorPipeline: 'Monitor your viral clip generation pipeline',
      refresh: 'Refresh',
      seedDemoData: 'Seed Demo Data',
      totalClips: 'Total Clips',
      totalViews: 'Total Views',
      totalLikes: 'Total Likes',
      engagementRate: 'Engagement Rate',
      vsLastWeek: 'vs last week',
      performanceOverview: 'Performance Overview',
      processingQueue: 'Processing Queue',
      active: 'Active',
      noActiveJobs: 'No active jobs',
      recentClips: 'Recent Clips',
      published: 'Published',
      noClipsYet: 'No clips generated yet',
      generateDemoClips: 'Generate Demo Clips',
      demoDataSeeded: 'Demo data seeded successfully!',
    },
    // Landing Page
    landing: {
      poweredByAI: 'Powered by AI',
      heroTitle: 'Transform Long Videos into',
      heroHighlight: 'Viral Clips',
      heroDescription: 'AI automatically discovers the most viral moments in videos, generates eye-catching clips with hypnotic subtitles, and publishes them to all your social media accounts.',
      getStartedFree: 'Get Started Free',
      watchDemo: 'Watch Demo',
      trustedBy: 'Trusted by content creators worldwide',
      login: 'Login',
      getStarted: 'Get Started',
      features: {
        discovery: {
          title: 'Automatic Discovery',
          description: 'AI finds the most viral moments in any podcast video'
        },
        subtitles: {
          title: 'Hypnotic Subtitles',
          description: 'Word-by-word animated captions that keep viewers engaged'
        },
        titles: {
          title: 'Viral Title Generator',
          description: 'AI generates titles with highest click-through rates'
        },
        publishing: {
          title: 'Multi-Platform Publishing',
          description: 'Publish to YouTube Shorts, TikTok, and Instagram Reels'
        }
      }
    },
    // Discovery
    discovery: {
      title: 'Discover Podcasts',
      subtitle: 'Search and add podcasts for viral clip generation',
      searchPlaceholder: 'Search podcasts, channels, or topics...',
      search: 'Search',
      trending: 'Agent Discoveries',
      searchResults: 'Search Results',
      addForProcessing: 'Add for Processing',
      addByUrl: 'Add by YouTube URL',
      pasteUrl: 'Paste YouTube video URL...',
      addVideo: 'Add Video',
      found: 'Found',
      podcasts: 'podcasts',
      podcastAdded: 'Podcast added for processing!',
      alreadyAdded: 'Podcast already added',
      invalidUrl: 'Invalid YouTube URL',
      filters: 'Filters',
      selectTheme: 'Select Theme',
      allThemes: 'All Themes',
      selectLanguage: 'Select Language',
      allLanguages: 'All Languages',
      myPodcasts: 'My Podcasts',
      noPodcasts: 'No podcasts added yet',
      addPodcastHint: 'Add podcasts from Trending tab or by URL',
      analyze: 'Analyze',
      noSearchResults: 'No search results',
      searchHint: 'Search for podcasts to find viral content opportunities',
    },
    // Clips
    clips: {
      title: 'Clips Library',
      subtitle: 'Manage your generated viral clips',
      searchClips: 'Search clips...',
      allClips: 'All Clips',
      pending: 'Pending',
      rendering: 'Rendering',
      ready: 'Ready',
      published: 'Published',
      generateViralTitles: 'Generate Viral Titles',
      schedulePublish: 'Schedule Publish',
      copyId: 'Copy ID',
      delete: 'Delete',
      noClipsFound: 'No clips found',
      aiGeneratedTitles: 'AI-Generated Viral Titles',
      predictedCtr: 'Predicted CTR',
      titleCopied: 'Title copied to clipboard',
      clipDeleted: 'Clip deleted',
      platform: 'Platform',
      schedule: 'Schedule',
      cancel: 'Cancel',
      scheduled: 'Scheduled for',
    },
    // Publishing
    publishing: {
      title: 'Publishing Queue',
      subtitle: 'Schedule and publish clips to social platforms',
      queued: 'Queued',
      scheduled: 'Scheduled',
      publishing: 'Publishing',
      failed: 'Failed',
      publishNow: 'Publish Now',
      noJobsInQueue: 'No jobs in queue',
      scheduleFromClips: 'Schedule clips from the Clips Library to publish',
      platformConnections: 'Platform Connections',
      connected: 'Connected',
      notConnected: 'Not connected',
      connect: 'Connect',
      disconnect: 'Disconnect',
      connectInSettings: 'Connect platforms in Settings to enable automatic publishing',
      publishingStarted: 'Publishing started!',
      jobCancelled: 'Job cancelled',
    },
    // Analytics
    analytics: {
      title: 'Analytics',
      subtitle: 'Track your clip performance across platforms',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
      last90Days: 'Last 90 days',
      totalViews: 'Total Views',
      totalLikes: 'Total Likes',
      comments: 'Comments',
      engagementRate: 'Engagement Rate',
      performanceTrends: 'Performance Trends',
      platformDistribution: 'Platform Distribution',
      platformPerformance: 'Platform Performance',
      topPerformingClips: 'Top Performing Clips',
      views: 'Views',
      likes: 'Likes',
      retention: 'retention',
      noClipData: 'No clip data yet',
    },
    // Reports
    reports: {
      title: 'Weekly Reports',
      subtitle: 'Performance insights and growth metrics',
      generateReport: 'Generate Report',
      latestReport: 'Latest Report',
      weeklySummary: 'Weekly Performance Summary',
      growthRate: 'Growth rate',
      clipsGenerated: 'Clips Generated',
      clipsPublished: 'Clips Published',
      topPerformingClips: 'Top Performing Clips',
      bestPostingTimes: 'Best Posting Times',
      trendingTopics: 'Trending Topics',
      previousReports: 'Previous Reports',
      noReportsYet: 'No reports generated yet',
      generateFirst: 'Generate First Report',
      reportGenerated: 'Report generated successfully!',
    },
    // Settings
    settings: {
      title: 'Settings',
      subtitle: 'Configure your viral clips platform',
      general: 'General',
      platforms: 'Platforms',
      apiKeys: 'API Keys',
      clipGeneration: 'Clip Generation',
      clipGenerationDesc: 'Configure how clips are generated from podcasts',
      minDuration: 'Minimum Duration (seconds)',
      maxDuration: 'Maximum Duration (seconds)',
      clipsPerVideo: 'Clips Per Video',
      viralityThreshold: 'Virality Threshold',
      viralityThresholdDesc: 'Only segments with virality score above this threshold will be clipped',
      subtitleStyle: 'Subtitle Style',
      boldAnimated: 'Bold Animated',
      minimal: 'Minimal',
      karaokeStyle: 'Karaoke Style',
      cinematic: 'Cinematic',
      automation: 'Automation',
      automationDesc: 'Control automatic processing features',
      autoDiscovery: 'Auto Discovery',
      autoDiscoveryDesc: 'Automatically search for new podcasts based on keywords',
      autoPublish: 'Auto Publish',
      autoPublishDesc: 'Automatically publish clips when ready',
      saveSettings: 'Save Settings',
      settingsSaved: 'Settings saved successfully',
      apiConfiguration: 'API Configuration',
      apiConfigurationDesc: 'Configure API keys for AI services and integrations',
      usingEmergentKey: 'Using Emergent Universal Key',
      emergentKeyDesc: 'Transcription and title generation are powered by the Emergent LLM Key',
      youtubeApiKey: 'YouTube Data API Key (Optional)',
      youtubeApiKeyDesc: 'Required for live YouTube search. Demo mode uses simulated data.',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      close: 'Close',
      confirm: 'Confirm',
      systemOnline: 'System Online',
      processingEngine: 'Processing Engine',
      active: 'Active',
    },
    // Job Types
    jobTypes: {
      fullPipeline: 'Full Pipeline',
      viralAnalysis: 'Viral Analysis',
      renderClip: 'Rendering',
      transcription: 'Transcription',
    },
  },
  
  'pt-BR': {
    // Navigation
    nav: {
      dashboard: 'Painel',
      discovery: 'Descoberta',
      clipsLibrary: 'Biblioteca de Clipes',
      publishing: 'Publicação',
      analytics: 'Análises',
      reports: 'Relatórios',
      settings: 'Configurações',
    },
    // Auth
    auth: {
      createAccount: 'Criar Conta',
      startFreeTrial: 'Comece seu teste gratuito hoje',
      fullName: 'Nome Completo',
      password: 'Senha',
      referralCode: 'Código de Indicação',
      optional: 'Opcional',
      termsAgree: 'Ao criar uma conta, você concorda com nossos Termos de Serviço e Política de Privacidade',
      haveAccount: 'Já tem uma conta?',
      signIn: 'Entrar',
      verifyEmail: 'Verificar Email',
      verificationSentTo: 'Enviamos um código de verificação para',
      verificationCode: 'Código de Verificação',
      resendCode: 'Reenviar Código',
      changeEmail: 'Usar outro email',
      verificationCodeSent: 'Código de verificação enviado para seu email',
      emailVerified: 'Email verificado com sucesso!',
      invalidCode: 'Por favor, insira um código válido de 6 dígitos',
      codeSent: 'Novo código de verificação enviado',
      accountCreated: 'Conta criada com sucesso!',
      registrationFailed: 'Falha no cadastro',
      verificationFailed: 'Falha na verificação',
      resendFailed: 'Falha ao reenviar código',
      passwordMinLength: 'A senha deve ter pelo menos 6 caracteres',
    },
    // Account
    account: {
      title: 'Conta',
      changePassword: 'Alterar Senha',
      changePasswordDesc: 'Atualize a senha da sua conta',
      currentPassword: 'Senha Atual',
      newPassword: 'Nova Senha',
      confirmPassword: 'Confirmar Nova Senha',
      passwordChanged: 'Senha alterada com sucesso',
      passwordChangeFailed: 'Falha ao alterar senha',
      passwordMismatch: 'As senhas não coincidem',
      accountInfo: 'Informações da Conta',
      plan: 'Plano',
      emailVerified: 'Email Verificado',
      verified: 'Verificado',
      notVerified: 'Não Verificado',
    },
    // Dashboard
    dashboard: {
      welcomeBack: 'Bem-vindo de Volta',
      monitorPipeline: 'Monitore seu pipeline de geração de clipes virais',
      refresh: 'Atualizar',
      seedDemoData: 'Carregar Dados Demo',
      totalClips: 'Total de Clipes',
      totalViews: 'Total de Views',
      totalLikes: 'Total de Curtidas',
      engagementRate: 'Taxa de Engajamento',
      vsLastWeek: 'vs semana passada',
      performanceOverview: 'Visão Geral de Desempenho',
      processingQueue: 'Fila de Processamento',
      active: 'Ativos',
      noActiveJobs: 'Nenhum trabalho ativo',
      recentClips: 'Clipes Recentes',
      published: 'Publicados',
      noClipsYet: 'Nenhum clipe gerado ainda',
      generateDemoClips: 'Gerar Clipes Demo',
      demoDataSeeded: 'Dados demo carregados com sucesso!',
    },
    // Landing Page
    landing: {
      poweredByAI: 'Impulsionado por IA',
      heroTitle: 'Transforme Vídeos Longos em',
      heroHighlight: 'Clipes Virais',
      heroDescription: 'A IA descobre automaticamente os momentos mais virais em vídeos, gera clipes atraentes com legendas hipnóticas e publica em todas as suas redes sociais.',
      getStartedFree: 'Começar Grátis',
      watchDemo: 'Ver Demo',
      trustedBy: 'Confiado por criadores de conteúdo no mundo todo',
      login: 'Entrar',
      getStarted: 'Começar',
      features: {
        discovery: {
          title: 'Descoberta Automática',
          description: 'A IA encontra os momentos mais virais em qualquer vídeo de podcast'
        },
        subtitles: {
          title: 'Legendas Hipnóticas',
          description: 'Legendas animadas palavra por palavra que mantêm os espectadores engajados'
        },
        titles: {
          title: 'Gerador de Títulos Virais',
          description: 'A IA gera títulos com as maiores taxas de clique'
        },
        publishing: {
          title: 'Publicação Multiplataforma',
          description: 'Publique no YouTube Shorts, TikTok e Instagram Reels'
        }
      }
    },
    // Discovery
    discovery: {
      title: 'Descobrir Podcasts',
      subtitle: 'Pesquise e adicione podcasts para geração de clipes virais',
      searchPlaceholder: 'Pesquisar podcasts, canais ou tópicos...',
      search: 'Pesquisar',
      trending: 'Descobertas do Agente',
      searchResults: 'Resultados da Pesquisa',
      addForProcessing: 'Adicionar para Processamento',
      addByUrl: 'Adicionar por URL do YouTube',
      pasteUrl: 'Cole a URL do vídeo do YouTube...',
      addVideo: 'Adicionar Vídeo',
      found: 'Encontrados',
      podcasts: 'podcasts',
      podcastAdded: 'Podcast adicionado para processamento!',
      alreadyAdded: 'Podcast já adicionado',
      invalidUrl: 'URL do YouTube inválida',
      filters: 'Filtros',
      selectTheme: 'Selecionar Tema',
      allThemes: 'Todos os Temas',
      selectLanguage: 'Selecionar Idioma',
      allLanguages: 'Todos os Idiomas',
      myPodcasts: 'Meus Podcasts',
      noPodcasts: 'Nenhum podcast adicionado ainda',
      addPodcastHint: 'Adicione podcasts da aba Em Alta ou por URL',
      analyze: 'Analisar',
      noSearchResults: 'Nenhum resultado de busca',
      searchHint: 'Busque por podcasts para encontrar oportunidades de conteúdo viral',
    },
    // Clips
    clips: {
      title: 'Biblioteca de Clipes',
      subtitle: 'Gerencie seus clipes virais gerados',
      searchClips: 'Buscar clipes...',
      allClips: 'Todos os Clipes',
      pending: 'Pendente',
      rendering: 'Renderizando',
      ready: 'Pronto',
      published: 'Publicado',
      generateViralTitles: 'Gerar Títulos Virais',
      schedulePublish: 'Agendar Publicação',
      copyId: 'Copiar ID',
      delete: 'Excluir',
      noClipsFound: 'Nenhum clipe encontrado',
      aiGeneratedTitles: 'Títulos Virais Gerados por IA',
      predictedCtr: 'CTR Previsto',
      titleCopied: 'Título copiado para a área de transferência',
      clipDeleted: 'Clipe excluído',
      platform: 'Plataforma',
      schedule: 'Agendar',
      cancel: 'Cancelar',
      scheduled: 'Agendado para',
    },
    // Publishing
    publishing: {
      title: 'Fila de Publicação',
      subtitle: 'Agende e publique clipes nas redes sociais',
      queued: 'Na Fila',
      scheduled: 'Agendado',
      publishing: 'Publicando',
      failed: 'Falhou',
      publishNow: 'Publicar Agora',
      noJobsInQueue: 'Nenhum trabalho na fila',
      scheduleFromClips: 'Agende clipes da Biblioteca de Clipes para publicar',
      platformConnections: 'Conexões de Plataformas',
      connected: 'Conectado',
      notConnected: 'Não conectado',
      connect: 'Conectar',
      disconnect: 'Desconectar',
      connectInSettings: 'Conecte plataformas nas Configurações para habilitar publicação automática',
      publishingStarted: 'Publicação iniciada!',
      jobCancelled: 'Trabalho cancelado',
    },
    // Analytics
    analytics: {
      title: 'Análises',
      subtitle: 'Acompanhe o desempenho dos seus clipes nas plataformas',
      last7Days: 'Últimos 7 dias',
      last30Days: 'Últimos 30 dias',
      last90Days: 'Últimos 90 dias',
      totalViews: 'Total de Views',
      totalLikes: 'Total de Curtidas',
      comments: 'Comentários',
      engagementRate: 'Taxa de Engajamento',
      performanceTrends: 'Tendências de Desempenho',
      platformDistribution: 'Distribuição por Plataforma',
      platformPerformance: 'Desempenho por Plataforma',
      topPerformingClips: 'Clipes com Melhor Desempenho',
      views: 'Views',
      likes: 'Curtidas',
      retention: 'retenção',
      noClipData: 'Nenhum dado de clipe ainda',
    },
    // Reports
    reports: {
      title: 'Relatórios Semanais',
      subtitle: 'Insights de desempenho e métricas de crescimento',
      generateReport: 'Gerar Relatório',
      latestReport: 'Último Relatório',
      weeklySummary: 'Resumo Semanal de Desempenho',
      growthRate: 'Taxa de crescimento',
      clipsGenerated: 'Clipes Gerados',
      clipsPublished: 'Clipes Publicados',
      topPerformingClips: 'Clipes com Melhor Desempenho',
      bestPostingTimes: 'Melhores Horários para Postar',
      trendingTopics: 'Tópicos em Alta',
      previousReports: 'Relatórios Anteriores',
      noReportsYet: 'Nenhum relatório gerado ainda',
      generateFirst: 'Gerar Primeiro Relatório',
      reportGenerated: 'Relatório gerado com sucesso!',
    },
    // Settings
    settings: {
      title: 'Configurações',
      subtitle: 'Configure sua plataforma de clipes virais',
      general: 'Geral',
      platforms: 'Plataformas',
      apiKeys: 'Chaves de API',
      clipGeneration: 'Geração de Clipes',
      clipGenerationDesc: 'Configure como os clipes são gerados dos podcasts',
      minDuration: 'Duração Mínima (segundos)',
      maxDuration: 'Duração Máxima (segundos)',
      clipsPerVideo: 'Clipes por Vídeo',
      viralityThreshold: 'Limite de Viralidade',
      viralityThresholdDesc: 'Apenas segmentos com pontuação de viralidade acima deste limite serão cortados',
      subtitleStyle: 'Estilo de Legenda',
      boldAnimated: 'Negrito Animado',
      minimal: 'Minimalista',
      karaokeStyle: 'Estilo Karaokê',
      cinematic: 'Cinematográfico',
      automation: 'Automação',
      automationDesc: 'Controle recursos de processamento automático',
      autoDiscovery: 'Descoberta Automática',
      autoDiscoveryDesc: 'Pesquisar automaticamente novos podcasts com base em palavras-chave',
      autoPublish: 'Publicação Automática',
      autoPublishDesc: 'Publicar clipes automaticamente quando prontos',
      saveSettings: 'Salvar Configurações',
      settingsSaved: 'Configurações salvas com sucesso',
      apiConfiguration: 'Configuração de API',
      apiConfigurationDesc: 'Configure chaves de API para serviços de IA e integrações',
      usingEmergentKey: 'Usando Chave Universal Emergent',
      emergentKeyDesc: 'Transcrição e geração de títulos são alimentados pela Chave LLM Emergent',
      youtubeApiKey: 'Chave de API do YouTube (Opcional)',
      youtubeApiKeyDesc: 'Necessário para pesquisa ao vivo no YouTube. O modo demo usa dados simulados.',
    },
    // Common
    common: {
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      view: 'Visualizar',
      close: 'Fechar',
      confirm: 'Confirmar',
      systemOnline: 'Sistema Online',
      processingEngine: 'Motor de Processamento',
      active: 'Ativo',
    },
    // Job Types
    jobTypes: {
      fullPipeline: 'Pipeline Completo',
      viralAnalysis: 'Análise Viral',
      renderClip: 'Renderização',
      transcription: 'Transcrição',
    },
  },
};

export default translations;
